import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Routes as R } from 'common/enums';
import styles from './inventoryNav.module.css';

const InventoryNav: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.navContainer}>
      <NavLink 
        to={R.InventoryItemsList} 
        className={styles.navItem}
        activeClassName={styles.navItemActive}
        exact
      >
        {t('admin.inventory.items.title')}
      </NavLink>
      <NavLink 
        to={R.StockMovementsList} 
        className={styles.navItem}
        activeClassName={styles.navItemActive}
        exact
      >
        {t('admin.inventory.movements.title')}
      </NavLink>
      <NavLink 
        to={R.RecipesList} 
        className={styles.navItem}
        activeClassName={styles.navItemActive}
        exact
      >
        {t('admin.inventory.recipes.title')}
      </NavLink>
    </div>
  );
};

export default InventoryNav;
